import {default as NextImage, ImageProps} from "next/image";
import {ReactNode, useState} from "react";
import {SkeletonLoading} from "@/base/components/SkeletonLoading";
import {useReadyEffect} from "@/base/utils/useReadyEffect";

type Props = {
	src: string,
	css?: any,
	className?: string,
	bodyClassName?: string,
	layoutOnlyWhenLoad?: boolean,
	loadAfterReady?: boolean,
	loadingChildren?: ReactNode,
} & Omit<ImageProps, 'onLoadingComplete'>;

export const LImage = ({
	src,
	bodyClassName = '',
	layoutOnlyWhenLoad = false,
	loadAfterReady = true,
	loadingChildren = null,
	...props
}: Props) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [firstload, setFirstLoad] = useState(false);

	const handleLoad = () => {
		setFirstLoad(true);
	}

	useReadyEffect(() => {
		handleLoad();
	}, []);

	const imageProps = {
		...props,
	}

	if (src.startsWith('//'))
	{
		src = 'https:' + src;
	}

	return (
		<SkeletonLoading className={`${props.className}`} loading={!isLoaded}>
			{firstload ? <NextImage
				{...imageProps}
				src={src}
				className={`duration-150 ${firstload && 'transition-colors transition-opacity'} ${bodyClassName} ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
				layout={layoutOnlyWhenLoad && !isLoaded ? undefined : (props?.layout || undefined)}
				onLoadingComplete={() => {
					setIsLoaded(true)
				}}
				loading={props.loading || 'lazy'}
				priority={props.priority || false}
				fetchPriority={props.fetchPriority || 'low'}
			/> : (loadingChildren ? loadingChildren : <div>
				<div className={``} style={{width: props.width, height: props.height}}/>
			</div>)}
		</SkeletonLoading>
	);
};
